<template>
   <header id="header" class="header d-flex align-items-center fixed-top">
    <div class="container-fluid container-xl position-relative d-flex align-items-center justify-content-between">

      <router-link to="/" class="logo d-flex align-items-center">
        <!-- Uncomment the line below if you also wish to use an image logo 
        <img src="../../assets/images/logo.png" alt="">-->
        <img src="../../assets/images/anagemw.png" alt="logoAnagem">
        <!-- <h1 class="sitename">AnaGem</h1>-->
      </router-link>

      <nav id="navmenu" class="navmenu">
        <ul>
          <li><a href="#" class="lien">Qui sommes-nous ?</a></li>
          <li><router-link to="/login" class="lien">Connexion</router-link></li>
        </ul>
        <i class="mobile-nav-toggle d-xl-none bi bi-list"  @click="toggleMobileNav"></i>
      </nav>

    </div>
  </header>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

export default defineComponent({
  name: "HeaderV",
  setup() {
    //
    const isMobileNavActive = ref(false);

    const toggleMobileNav = (): void => {
      const body = document.body;
      isMobileNavActive.value = !isMobileNavActive.value;

      if (isMobileNavActive.value) {
        body.classList.add("mobile-nav-active");
      } else {
        body.classList.remove("mobile-nav-active");
      }
    };

    return {
      isMobileNavActive,
      toggleMobileNav,
    };
  },
});
</script>
<style scoped>
.lien {
  text-decoration: none;
}

.header {
  --background-color: rgba(21, 40, 29, 0.9);
}
.scrolled .header {
    --background-color: rgba(20, 46, 108, 0.9);
}
</style>